import React from 'react';
import ReactDOM from 'react-dom/client';
import App from '../src/components/app/App';
import  { BrowserRouter } from "react-router-dom";

import './styles/style.scss'

const wrapper = ReactDOM.createRoot(document.getElementById('wrapper'));
wrapper.render(
  <React.StrictMode>
    <BrowserRouter>
      <App/>
    </BrowserRouter>
  </React.StrictMode>
);